import React from 'react';
import {getPageData} from '../../sources/CmsSource';
import {useGetPageData} from '../../actions/CmsActions';
import IndustryContainer from './Industry.container';
import {extractSlugLocale} from '@epic-core/localization';
import {getLocale} from '@epic-core/common';

interface Properties {
    location: any;
}

const hasValidFaqPageData = (faq: any = {}) => {
    return faq && faq.faqList && faq.faqList.length;
};

const IndustryView = ({location = {}}: Properties) => {
    const pathname = location.pathname || '';
    const {pageSlug} = extractSlugLocale(pathname, getLocale());
    const pageData = useGetPageData({cmsUrlPattern: pageSlug}) || {};

    const {faq = {}, ...page} = pageData;

    if (hasValidFaqPageData(faq)) {
        page.faq = faq;
    }

    return <IndustryContainer key={pageSlug} pageData={page} />;
};

IndustryView.getInitialProps = async (match, {locale}, requestedUrl) => {
    const {pageSlug} = extractSlugLocale(requestedUrl, getLocale());

    let rawPageData = {};

    try {
        rawPageData = await getPageData(pageSlug);
    } catch (e) {
        console.error('IndustryView failed to load on the server', pageSlug);
        console.error(e.message);
    }

    //must match structure of StoreProvider
    return {
        cms: {
            [pageSlug]: rawPageData
        }
    };
};

export default IndustryView;
